import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../../sdk/UserSession.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { pushChanges1lnw8bjwewvzf as pushChanges } from '../../../utils/Draft.ext.mjs';
import {
  MemberRole_Employee_getInstance37kv78awnpbvk as MemberRole_Employee_getInstance,
  get_entries1ltxg9ate1zwh as get_entries,
  MemberRole_Manager_getInstance3dbaoot8q9evq as MemberRole_Manager_getInstance,
  MemberRole_Admin_getInstance3iiznt2spfc6m as MemberRole_Admin_getInstance,
  UserRole_Customer_getInstance1i1qwr4axl8qb as UserRole_Customer_getInstance,
} from '../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import {
  AddUserToMembership17wfynuguc0xh as AddUserToMembership,
  Addresscpovxna1tjmg as Address,
  UserMembership38xnkdta6uihl as UserMembership,
} from '../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { PlainTextException3c81a0qh9m2e2 as PlainTextException } from '../../../../../../kiteui-library/com/lightningkite/kiteui/exceptions/handling.mjs';
import { LsErrorException1ikb4g50zc2ko as LsErrorException } from '../../../../../../lightning-server-kiteui-client/com/lightningkite/lightningserver/LsErrorException.mjs';
import {
  get_dialogStackleaqvayyucjw as get_dialogStack,
  get_viewIsWide3s4g60a9e0192 as get_viewIsWide,
  get_viewIsNarrow26l63sh4olw2h as get_viewIsNarrow,
} from '../../components/nav/crowpay.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  RowCollapsingToColumn13iucsgmjquhb as RowCollapsingToColumn,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../components/nav/AppDimensions.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  get_expanding10cuv3ua9vajx as get_expanding,
  forEachUpdating2xo34s2yjc7ia as forEachUpdating,
  get_atEnd1cw5d2zgug26 as get_atEnd,
  get_atStart2tgdnaxgj04ln as get_atStart,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  bodyBold2czwdzwknab0k as bodyBold,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  SmallBodySemantic_getInstance13vsg4635cu56 as SmallBodySemantic_getInstance,
  SubtitleSemantic_getInstance37873sehsd699 as SubtitleSemantic_getInstance,
  smallBody2trfy14zwtona as smallBody,
  title1nssp3ryhwuqj as title,
} from '../../theming/Titles.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../theming/AppColors.mjs';
import { colored3y8uibz1hk46 as colored } from '../../theming/colorManagement.mjs';
import {
  FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance,
  DialogSemantic_getInstance3cqn6ufjbbrs2 as DialogSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
import { User8yb1tqk4kykg as User } from '../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  DataClassPathSelf9694s3fei65z as DataClassPathSelf,
  get_notNull2xk5v9at1ay9v as get_notNull,
} from '../../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import {
  get_membership2p5yrn2d458jx as get_membership,
  get_addressm9hct5lany5j as get_address,
} from '../../../../../../crowpay-shared/com/crowpay/UserFields.mjs';
import {
  get_role1cuv52bfv4mxp as get_role,
  get_contractor238fhmgszzker as get_contractor,
} from '../../../../../../crowpay-shared/com/crowpay/UserMembershipFields.mjs';
import {
  lensPath16mstx1fbm6dz as lensPath,
  lensPath2kkrykycsgvs9 as lensPath_0,
} from '../../../../../../lightning-server-kiteui-client/com/lightningkite/serialization/MutableReactive.lens.DataClassPath.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
  Signal1973xs1vkmdcb as Signal,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { GenericConfirmationDialog172k63mmx5r2d as GenericConfirmationDialog } from '../../dialogs/GenericConfirmationDialog.mjs';
import { get_fullName2ompl3bj5l3sh as get_fullName } from '../../../../../../crowpay-shared/com/crowpay/extensions/User.ext.shared.mjs';
import {
  DangerButtonSemantic_getInstanceb7gofax87736 as DangerButtonSemantic_getInstance,
  specCenteredText1zemopd0g3rsf as specCenteredText,
  get_dangerButtonciwpmvl7jmt2 as get_dangerButton,
  get_secondaryButtondor94xxt3ws3 as get_secondaryButton,
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  get_tertiaryButton1h22y4lorv47t as get_tertiaryButton,
} from '../../theming/buttons.mjs';
import { verifyContractor3ixd4tkg6xaiu as verifyContractor } from './IsContractorScreen.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import {
  shownDefaultFalse3hpz4awymyomc as shownDefaultFalse,
  flatten286v3fmuz892n as flatten,
  Action1a4ymn5nx79hk as Action,
} from '../../../utils/utils.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { get_section1qyzr1npzel2z as get_section } from '../../theming/sections.mjs';
import { Dimensions32ju1l7z4mh as Dimension } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { get_compact3lsezez8nz8b6 as get_compact } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  _EmailAddress___get_raw__impl__6ose21hsaqj8b5ou10 as _EmailAddress___get_raw__impl__6ose2,
  _EmailAddress___init__impl__a6ugvr3vyholn0wwoi2 as _EmailAddress___init__impl__a6ugvr,
  _PhoneNumber___init__impl__slwhzyo93bblbw66x0 as _PhoneNumber___init__impl__slwhzy,
  EmailAddress1n0o8cqqfp9qz as EmailAddress,
} from '../../../../../../lightning-server-shared/com/lightningkite/StringAlts.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
  get_scrolling27q1yr4ng0cx8 as get_scrolling,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { shownWhenxgf1ujy6rmvr as shownWhen } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { validatedmmpm5lnzq3lm as validated } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/entrypoints.mjs';
import { addressForm32k03uh8crpev as addressForm } from '../../components/addressForm.mjs';
import { Draft43syxm8fng0j as Draft } from '../../../../../../reactive/com/lightningkite/reactive/core/Draft.mjs';
import { validated2q9ie09qg9r46 as validated_0 } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/ValidatedDraft.mjs';
import { UserForm7kih3xavfx72 as UserForm } from '../client/UserForm.mjs';
import { DismissBackground1nezyx9ss0e1b as DismissBackground } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/DismissBackground.commonHtml.mjs';
import { RemoveOutline_getInstance2r2ekg5cxorga as RemoveOutline_getInstance } from '../../theming/appTheme.mjs';
import { render38qn7o0b2bza2 as render } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Routes.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { get_issues1z1skb5sgeygq as get_issues } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { get_selectedContractor2m4vxuqdzv6k3 as get_selectedContractor } from '../../../selectedContractor.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { eq1298m2cje971u as eq } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/ConditionBuilder.mjs';
import { Query38t34cs21ulcf as Query } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Query.mjs';
import { sortedWith2csnbbb21k0lg as sortedWith } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { IssueNode2x8c6ia7dmfdz as IssueNode } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/IssueNode.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, confirmed, $completion) {
  if (!confirmed)
    return Unit_instance;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  try {
    var tmp_0 = pushChanges($this.jjn_1.gjn_1, session.afw_1, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  } catch ($p) {
    if ($p instanceof LsErrorException()) {
      var e = $p;
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_1 = $this.jjn_1.gjn_1;
      var tmp_1 = await_0(this_1, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      var user = tmp_1;
      var tmp_2 = session.vfw().cfh_1;
      var tmp0_safe_receiver = user.k88_1;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h8c_1;
      var tmp_3 = tmp_2.bfs(new (AddUserToMembership())(user.e88_1, tmp1_elvis_lhs == null ? MemberRole_Employee_getInstance() : tmp1_elvis_lhs), $completion);
      if (tmp_3 === get_COROUTINE_SUSPENDED())
        tmp_3 = yield tmp_3;
      var tmp2_safe_receiver = tmp_3;
      var tmp_4;
      if (tmp2_safe_receiver == null) {
        tmp_4 = null;
      } else {
        // Inline function 'kotlin.also' call
        session.afw_1.feo(tmp2_safe_receiver);
        tmp_4 = tmp2_safe_receiver;
      }
      if (tmp_4 == null)
        throw PlainTextException().lcw("Error in adding user, this shouldn't happen, please report this. Error: " + e.toString());
    } else {
      throw $p;
    }
  }
  get_dialogStack().pgd();
  return Unit_instance;
}
function ManageContractorUsers$AddUserDialog$render$slambda$lambda($this$GenericConfirmationDialog) {
  get_dialogStack().pgd();
  return Unit_instance;
}
var ManageContractorUsers$AddUserDialog$render$slambda$slambdaClass;
function ManageContractorUsers$AddUserDialog$render$slambda$slambda() {
  if (ManageContractorUsers$AddUserDialog$render$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.jjn_1 = this$0;
      }
      egk(confirmed, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, confirmed), $completion);
      }
      s2(p1, $completion) {
        return this.egk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ManageContractorUsers$AddUserDialog$render$slambda$slambdaClass = $;
  }
  return ManageContractorUsers$AddUserDialog$render$slambda$slambdaClass;
}
function ManageContractorUsers$AddUserDialog$render$slambda$slambda_0(this$0) {
  var i = new (ManageContractorUsers$AddUserDialog$render$slambda$slambda())(this$0);
  var l = (confirmed, $completion) => i.egk(confirmed, $completion);
  l.$arity = 1;
  return l;
}
function roleSelector($this, _this__u8e3s4) {
  // Inline function 'com.crowpay.views.components.requiredField' call
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(true);
  view.bb9(get_AppDimensions().pg2_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view_0.zbm(false);
  view_0.bb9(get_AppDimensions().rg2_1);
  view_0.lbb(get_centered(view_0), bodyBold(view_0, 'Role'));
  view_0.lbb(colored(view_0, AppColors_getInstance().jfz_1.zg9_1), bodyBold(view_0, '*'));
  view.hbb(p_0, view_0);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = view.jbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.select' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (Select())(view.pc());
  var tmp0_elvis_lhs_1 = view.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
  view.gbb(p_1, view_1);
  // Inline function 'com.lightningkite.serialization.lensPath' call
  var this_0 = $this.gjn_1;
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_0 = serializerOrContextual(createKType(getKClass(User()), arrayOf([]), false));
  var tmp$ret$5 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
  var it = new (DataClassPathSelf())(tmp$ret$5);
  var tmp$ret$7 = get_role(get_notNull(get_membership(it)));
  var tmp_1 = lensPath(this_0, tmp$ret$7);
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = get_entries();
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = tmp0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    if (element.d4($this.fjn_1.h8c_1) <= 0) {
      destination.v(element);
    }
  }
  var tmp_2 = _Constant___init__impl__v45mub(destination);
  view_1.ocf(tmp_1, new (Constant())(tmp_2), ManageContractorUsers$AddUserDialog$roleSelector$lambda);
  view.hbb(p_1, view_1);
  view.lbb(tmp, view_1);
  _this__u8e3s4.hbb(p, view);
  return view;
}
function ManageContractorUsers$AddUserDialog$roleSelector$lambda(it) {
  return it.a4_1;
}
var ManageContractorUsers$AddUserDialog$render$slambdaClass;
function ManageContractorUsers$AddUserDialog$render$slambda() {
  if (ManageContractorUsers$AddUserDialog$render$slambdaClass === VOID) {
    class $ {
      uao($completion) {
        get_dialogStack().pgd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ManageContractorUsers$AddUserDialog$render$slambdaClass = $;
  }
  return ManageContractorUsers$AddUserDialog$render$slambdaClass;
}
function ManageContractorUsers$AddUserDialog$render$slambda_0() {
  var i = new (ManageContractorUsers$AddUserDialog$render$slambda())();
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var ManageContractorUsers$AddUserDialog$render$slambdaClass_0;
function ManageContractorUsers$AddUserDialog$render$slambda_1() {
  if (ManageContractorUsers$AddUserDialog$render$slambdaClass_0 === VOID) {
    class $ {
      uao($completion) {
        get_dialogStack().pgd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ManageContractorUsers$AddUserDialog$render$slambdaClass_0 = $;
  }
  return ManageContractorUsers$AddUserDialog$render$slambdaClass_0;
}
function ManageContractorUsers$AddUserDialog$render$slambda_2() {
  var i = new (ManageContractorUsers$AddUserDialog$render$slambda_1())();
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
var ManageContractorUsers$AddUserDialog$render$slambdaClass_1;
function ManageContractorUsers$AddUserDialog$render$slambda_3() {
  if (ManageContractorUsers$AddUserDialog$render$slambdaClass_1 === VOID) {
    class $ {
      constructor(this$0) {
        this.kjn_1 = this$0;
      }
      uao($completion) {
        var tmp = get_dialogStack();
        var tmp_0 = ManageContractorUsers$AddUserDialog$render$slambda$lambda;
        tmp.zgd(new (GenericConfirmationDialog())('Add User to Account', 'Are you sure you want to add this user to your account?', VOID, 'Add User', VOID, VOID, VOID, VOID, tmp_0, VOID, ManageContractorUsers$AddUserDialog$render$slambda$slambda_0(this.kjn_1)));
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ManageContractorUsers$AddUserDialog$render$slambdaClass_1 = $;
  }
  return ManageContractorUsers$AddUserDialog$render$slambdaClass_1;
}
function ManageContractorUsers$AddUserDialog$render$slambda_4(this$0) {
  var i = new (ManageContractorUsers$AddUserDialog$render$slambda_3())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = tmp.rfw_1;
  var tmp_0 = await_0(this_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp0_elvis_lhs = tmp_0.k88_1;
  var tmp_1;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_1 = tmp0_elvis_lhs;
  }
  var membership = tmp_1;
  get_dialogStack().zgd(new (AddUserDialog())(membership));
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_1($this, confirmed, $completion) {
  if (!confirmed)
    return Unit_instance;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = get_session();
  var tmp_0 = await_0(this_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0.vfw().cfh_1.cfs($this.ljn_1.d88_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var result = session.afw_1.feo(tmp_1);
  var tmp_2 = (it) => it.d88_1.equals($this.ljn_1.d88_1);
  session.afw_1.eeo(tmp_2, (it) => result);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_2($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.mjn_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var user = tmp;
  var tmp_0 = get_dialogStack();
  var tmp_1 = 'Are you sure you want to remove ' + get_fullName(user) + ' from your account? This cannot be undone.';
  var tmp_2 = 'Remove ' + get_fullName(user);
  var tmp_3 = DangerButtonSemantic_getInstance();
  tmp_0.zgd(new (GenericConfirmationDialog())('Remove User', tmp_1, VOID, tmp_2, VOID, tmp_3, VOID, VOID, VOID, VOID, ManageContractorUsers$renderUserSettings$lambda$slambda$slambda_0(user)));
  return Unit_instance;
}
var ManageContractorUsers$renderUserSettings$lambda$slambda$slambdaClass;
function ManageContractorUsers$renderUserSettings$lambda$slambda$slambda() {
  if (ManageContractorUsers$renderUserSettings$lambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor($user) {
        this.ljn_1 = $user;
      }
      egk(confirmed, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, confirmed), $completion);
      }
      s2(p1, $completion) {
        return this.egk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ManageContractorUsers$renderUserSettings$lambda$slambda$slambdaClass = $;
  }
  return ManageContractorUsers$renderUserSettings$lambda$slambda$slambdaClass;
}
function ManageContractorUsers$renderUserSettings$lambda$slambda$slambda_0($user) {
  var i = new (ManageContractorUsers$renderUserSettings$lambda$slambda$slambda())($user);
  var l = (confirmed, $completion) => i.egk(confirmed, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_3($this, confirmed, $completion) {
  if (confirmed) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_session();
    var tmp = await_0(this_0, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var userCache = tmp.afw_1;
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = $this.njn_1.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      var tmp_0 = pushChanges(element, userCache, $completion);
      if (tmp_0 === get_COROUTINE_SUSPENDED())
        tmp_0 = yield tmp_0;
    }
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_4($this, $this$Action, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.ojn_1.yiv_1.rat_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!tmp.i1()) {
    $this.ojn_1.ziv_1.oam(true);
    return Unit_instance;
  }
  $this.ojn_1.ziv_1.oam(false);
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.ojn_1.xiv_1;
  var tmp_0 = await_0(this_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = tmp_0;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = tmp0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = element.cak();
    var tmp_1 = await_0(this_2, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    if (tmp_1) {
      destination.v(element);
    }
  }
  var changed = destination;
  if (changed.i1())
    return Unit_instance;
  var tmp_2 = get_dialogStack();
  var tmp_3 = changed.p1() > 1 ? 'Save User Role Changes' : 'Change User Role';
  tmp_2.zgd(new (GenericConfirmationDialog())(tmp_3, 'Confirm that you want to save these changes', VOID, 'Save Changes', VOID, VOID, VOID, VOID, VOID, VOID, ManageContractorUsers$save$slambda$slambda_0(changed)));
  return Unit_instance;
}
var ManageContractorUsers$save$slambda$slambdaClass;
function ManageContractorUsers$save$slambda$slambda() {
  if (ManageContractorUsers$save$slambda$slambdaClass === VOID) {
    class $ {
      constructor($changed) {
        this.njn_1 = $changed;
      }
      egk(confirmed, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this, confirmed), $completion);
      }
      s2(p1, $completion) {
        return this.egk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ManageContractorUsers$save$slambda$slambdaClass = $;
  }
  return ManageContractorUsers$save$slambda$slambdaClass;
}
function ManageContractorUsers$save$slambda$slambda_0($changed) {
  var i = new (ManageContractorUsers$save$slambda$slambda())($changed);
  var l = (confirmed, $completion) => i.egk(confirmed, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_5($this, $this$launch, $completion) {
  var tmp = verifyContractor($this.pjn_1, MemberRole_Manager_getInstance(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_6($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.qjn_1.xiv_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    element.nai();
  }
  return Unit_instance;
}
function addUsersButton($this, _this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Button())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  shownDefaultFalse(view, ($this$shownDefaultFalse) => $this$shownDefaultFalse.daj($this.tiv_1).d4(MemberRole_Manager_getInstance()) >= 0);
  specCenteredText(view, '+ Add User');
  onClick(view, VOID, VOID, ManageContractorUsers$addUsersButton$slambda_0());
  _this__u8e3s4.hbb(p, view);
  return view;
}
function renderUserSettings($this, _this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(true);
  forEachUpdating(view, $this.xiv_1, VOID, ($this$forEachUpdating, unflattened) => {
    var user = flatten(unflattened);
    var userRole = remember(VOID, VOID, VOID, ($this$remember) => {
      var tmp0_safe_receiver = $this$remember.daj($this$remember.daj(unflattened).aak()).k88_1;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h8c_1;
      return tmp1_elvis_lhs == null ? MemberRole_Employee_getInstance() : tmp1_elvis_lhs;
    });
    var tmp = get_section($this$forEachUpdating);
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())($this$forEachUpdating.pc());
    var tmp0_elvis_lhs = $this$forEachUpdating.ebb_1;
    var p = tmp0_elvis_lhs == null ? $this$forEachUpdating : tmp0_elvis_lhs;
    $this$forEachUpdating.gbb(p, view);
    view.zbm(true);
    // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
    var breakpoint = get_AppDimensions().hg2_1;
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (RowCollapsingToColumn())(view.pc(), listOf(new (Dimension())(breakpoint)));
    var tmp0_elvis_lhs_0 = view.ebb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.gbb(p_0, view_0);
    if (get_viewIsNarrow(view_0)) {
      var tmp_0 = get_compact(view_0);
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_1 = new (RowOrCol())(view_0.pc());
      var tmp0_elvis_lhs_1 = view_0.ebb_1;
      var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
      view_0.gbb(p_1, view_1);
      view_1.zbm(false);
      var tmp_1 = get_centered(view_1);
      // Inline function 'com.crowpay.views.theming.body' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_2 = new (TextView())(view_1.pc());
      var tmp0_elvis_lhs_2 = view_1.ebb_1;
      var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
      view_1.gbb(p_2, view_2);
      view_2.lba(view_2.qb6_1.abf(BodySemantic_getInstance()));
      var tmp_2 = KMutableProperty0();
      var tmp_3 = TextView$_get_content_$ref_4pzcwl(view_2);
      // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
      var this_0 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(view_2));
      reactiveScope(view_2, ($this$reactiveScope) => {
        var tmp$ret$0 = get_fullName($this$reactiveScope.daj(user));
        this_0.set(tmp$ret$0);
        return Unit_instance;
      });
      view_1.hbb(p_2, view_2);
      view_1.lbb(tmp_1, view_2);
      var tmp_4 = view_1.kbb(get_centered(view_1), get_expanding(view_1));
      // Inline function 'com.crowpay.views.theming.smallBody' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_3 = new (TextView())(view_1.pc());
      var tmp0_elvis_lhs_3 = view_1.ebb_1;
      var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
      view_1.gbb(p_3, view_3);
      view_3.lba(view_3.qb6_1.abf(SmallBodySemantic_getInstance()));
      view_3.acp(false);
      view_3.zco(true);
      var tmp_5 = KMutableProperty0();
      var tmp_6 = TextView$_get_content_$ref_4pzcwl_0(view_3);
      // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
      var this_1 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, TextView$_set_content_$ref_pketfb_0(view_3));
      reactiveScope(view_3, ($this$reactiveScope) => {
        var tmp$ret$7 = _EmailAddress___get_raw__impl__6ose2($this$reactiveScope.daj(user).e88_1);
        this_1.set(tmp$ret$7);
        return Unit_instance;
      });
      view_1.hbb(p_3, view_3);
      view_1.lbb(tmp_4, view_3);
      view_0.hbb(p_1, view_1);
      view_0.lbb(tmp_0, view_1);
    } else {
      var tmp_7 = view_0.kbb(get_compact(view_0), get_expanding(view_0));
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_4 = new (RowOrCol())(view_0.pc());
      var tmp0_elvis_lhs_4 = view_0.ebb_1;
      var p_4 = tmp0_elvis_lhs_4 == null ? view_0 : tmp0_elvis_lhs_4;
      view_0.gbb(p_4, view_4);
      view_4.zbm(true);
      view_4.zbm(get_viewIsWide(view_4));
      // Inline function 'com.crowpay.views.theming.body' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_5 = new (TextView())(view_4.pc());
      var tmp0_elvis_lhs_5 = view_4.ebb_1;
      var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
      view_4.gbb(p_5, view_5);
      view_5.lba(view_5.qb6_1.abf(BodySemantic_getInstance()));
      var tmp_8 = KMutableProperty0();
      var tmp_9 = TextView$_get_content_$ref_4pzcwl_1(view_5);
      // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
      var this_2 = getPropertyCallableRef('content', 0, tmp_8, tmp_9, TextView$_set_content_$ref_pketfb_1(view_5));
      reactiveScope(view_5, ($this$reactiveScope) => {
        var tmp$ret$18 = get_fullName($this$reactiveScope.daj(user));
        this_2.set(tmp$ret$18);
        return Unit_instance;
      });
      view_4.hbb(p_5, view_5);
      // Inline function 'com.crowpay.views.theming.smallBody' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_6 = new (TextView())(view_4.pc());
      var tmp0_elvis_lhs_6 = view_4.ebb_1;
      var p_6 = tmp0_elvis_lhs_6 == null ? view_4 : tmp0_elvis_lhs_6;
      view_4.gbb(p_6, view_6);
      view_6.lba(view_6.qb6_1.abf(SmallBodySemantic_getInstance()));
      var tmp_10 = KMutableProperty0();
      var tmp_11 = TextView$_get_content_$ref_4pzcwl_2(view_6);
      // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
      var this_3 = getPropertyCallableRef('content', 0, tmp_10, tmp_11, TextView$_set_content_$ref_pketfb_2(view_6));
      reactiveScope(view_6, ($this$reactiveScope) => {
        var tmp$ret$25 = _EmailAddress___get_raw__impl__6ose2($this$reactiveScope.daj(user).e88_1);
        this_3.set(tmp$ret$25);
        return Unit_instance;
      });
      view_4.hbb(p_6, view_6);
      view_0.hbb(p_4, view_4);
      view_0.lbb(tmp_7, view_4);
    }
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_7 = new (RowOrCol())(view_0.pc());
    var tmp0_elvis_lhs_7 = view_0.ebb_1;
    var p_7 = tmp0_elvis_lhs_7 == null ? view_0 : tmp0_elvis_lhs_7;
    view_0.gbb(p_7, view_7);
    view_7.zbm(false);
    var tmp_12 = view_7.kbb(view_7.kbb(get_centered(view_7), sizeConstraints(view_7, VOID, VOID, VOID, VOID, VOID, get_rem(8))), get_compact(view_7));
    // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
    var tmp$ret$36 = view_7.jbb(FieldSemantic_getInstance());
    var tmp_13 = view_7.kbb(tmp_12, tmp$ret$36);
    // Inline function 'com.lightningkite.kiteui.views.direct.select' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_8 = new (Select())(view_7.pc());
    var tmp0_elvis_lhs_8 = view_7.ebb_1;
    var p_8 = tmp0_elvis_lhs_8 == null ? view_7 : tmp0_elvis_lhs_8;
    view_7.gbb(p_8, view_8);
    var tmp_14 = KMutableProperty0();
    var tmp_15 = Select$_get_shown_$ref_flgnnd(view_8);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_4 = getPropertyCallableRef('shown', 0, tmp_14, tmp_15, Select$_set_shown_$ref_q4sxx7(view_8));
    reactiveScope(view_8, ($this$reactiveScope) => {
      var tmp$ret$37 = !$this$reactiveScope.daj(user).d88_1.equals($this$reactiveScope.daj(get_session()).gfv_1) && $this$reactiveScope.daj(userRole).d4($this$reactiveScope.daj($this.tiv_1)) <= 0;
      this_4.set(tmp$ret$37);
      return Unit_instance;
    });
    var tmp_16 = KMutableProperty0();
    var tmp_17 = Select$_get_enabled_$ref_eg5v13(view_8);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_5 = getPropertyCallableRef('enabled', 0, tmp_16, tmp_17, Select$_set_enabled_$ref_fu8bat(view_8));
    reactiveScope(view_8, ($this$reactiveScope) => {
      var tmp$ret$39 = $this$reactiveScope.daj(userRole).d4($this$reactiveScope.daj($this.tiv_1)) <= 0;
      this_5.set(tmp$ret$39);
      return Unit_instance;
    });
    // Inline function 'com.lightningkite.serialization.lensPath' call
    // Inline function 'com.lightningkite.lightningdb.path' call
    // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
    var tmp_18 = serializerOrContextual(createKType(getKClass(User()), arrayOf([]), false));
    var tmp$ret$41 = isInterface(tmp_18, KSerializer()) ? tmp_18 : THROW_CCE();
    var it = new (DataClassPathSelf())(tmp$ret$41);
    var tmp$ret$43 = get_role(get_notNull(get_membership(it)));
    var tmp_19 = lensPath_0(user, tmp$ret$43);
    var tmp_20 = remember(VOID, VOID, VOID, ($this$remember) => {
      // Inline function 'kotlin.collections.filter' call
      var tmp0 = get_entries();
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList().w();
      var _iterator__ex2g4s = tmp0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        if (element.d4($this$remember.daj($this.tiv_1)) <= 0) {
          destination.v(element);
        }
      }
      return destination;
    });
    view_8.ocf(tmp_19, tmp_20, ManageContractorUsers$renderUserSettings$lambda$lambda);
    view_7.hbb(p_8, view_8);
    view_7.lbb(tmp_13, view_8);
    var tmp_21 = view_7.kbb(view_7.kbb(get_centered(view_7), sizeConstraints(view_7, VOID, VOID, VOID, VOID, VOID, get_rem(8))), get_compact(view_7));
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_9 = new (TextView())(view_7.pc());
    var tmp0_elvis_lhs_9 = view_7.ebb_1;
    var p_9 = tmp0_elvis_lhs_9 == null ? view_7 : tmp0_elvis_lhs_9;
    view_7.gbb(p_9, view_9);
    var tmp_22 = KMutableProperty0();
    var tmp_23 = TextView$_get_shown_$ref_kipsub(view_9);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_6 = getPropertyCallableRef('shown', 0, tmp_22, tmp_23, TextView$_set_shown_$ref_l7jsq9(view_9));
    reactiveScope(view_9, ($this$reactiveScope) => {
      var tmp$ret$51 = $this$reactiveScope.daj(user).d88_1.equals($this$reactiveScope.daj(get_session()).gfv_1) || $this$reactiveScope.daj(userRole).d4($this$reactiveScope.daj($this.tiv_1)) > 0;
      this_6.set(tmp$ret$51);
      return Unit_instance;
    });
    var tmp_24 = KMutableProperty0();
    var tmp_25 = TextView$_get_content_$ref_4pzcwl_3(view_9);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_7 = getPropertyCallableRef('content', 0, tmp_24, tmp_25, TextView$_set_content_$ref_pketfb_3(view_9));
    reactiveScope(view_9, ($this$reactiveScope) => {
      var tmp$ret$53 = $this$reactiveScope.daj(userRole).a4_1;
      this_7.set(tmp$ret$53);
      return Unit_instance;
    });
    view_7.hbb(p_9, view_9);
    view_7.lbb(tmp_21, view_9);
    var tmp_26 = view_7.kbb(get_centered(view_7), get_dangerButton(view_7));
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_10 = new (Button())(view_7.pc());
    var tmp0_elvis_lhs_10 = view_7.ebb_1;
    var p_10 = tmp0_elvis_lhs_10 == null ? view_7 : tmp0_elvis_lhs_10;
    view_7.gbb(p_10, view_10);
    shownDefaultFalse(view_10, ($this$shownDefaultFalse) => {
      var tmp;
      // Inline function 'kotlin.let' call
      var it = $this$shownDefaultFalse.daj($this.tiv_1);
      if (it.d4(MemberRole_Manager_getInstance()) >= 0 && $this$shownDefaultFalse.daj(userRole).d4(it) <= 0) {
        tmp = !$this$shownDefaultFalse.daj(user).d88_1.equals($this$shownDefaultFalse.daj(get_session()).gfv_1);
      } else {
        tmp = false;
      }
      return tmp;
    });
    specCenteredText(view_10, 'Remove User');
    onClick(view_10, 'Remove user from account', VOID, ManageContractorUsers$renderUserSettings$lambda$slambda_0(user));
    view_7.hbb(p_10, view_10);
    view_7.lbb(tmp_26, view_10);
    view_0.hbb(p_7, view_7);
    view.hbb(p_0, view_0);
    var upgradingToAdmin = remember(VOID, VOID, VOID, ($this$remember) => {
      var draft = $this$remember.daj(unflattened);
      var tmp;
      var tmp0_safe_receiver = $this$remember.daj(draft).k88_1;
      if (equals(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h8c_1, MemberRole_Admin_getInstance())) {
        var tmp1_safe_receiver = $this$remember.daj(draft.aak()).k88_1;
        tmp = !equals(tmp1_safe_receiver == null ? null : tmp1_safe_receiver.h8c_1, MemberRole_Admin_getInstance());
      } else {
        tmp = false;
      }
      return tmp;
    });
    var tmp_27 = shownWhen(view, VOID, ($this$shownWhen) => $this$shownWhen.daj(upgradingToAdmin));
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_11 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_11 = view.ebb_1;
    var p_11 = tmp0_elvis_lhs_11 == null ? view : tmp0_elvis_lhs_11;
    view.gbb(p_11, view_11);
    view_11.zbm(true);
    var tmp_28 = get_compact(view_11);
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_12 = new (RowOrCol())(view_11.pc());
    var tmp0_elvis_lhs_12 = view_11.ebb_1;
    var p_12 = tmp0_elvis_lhs_12 == null ? view_11 : tmp0_elvis_lhs_12;
    view_11.gbb(p_12, view_12);
    view_12.zbm(true);
    // Inline function 'com.crowpay.views.theming.subTitle' call
    var content = 'Billing Address';
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_13 = new (TextView())(view_12.pc());
    var tmp0_elvis_lhs_13 = view_12.ebb_1;
    var p_13 = tmp0_elvis_lhs_13 == null ? view_12 : tmp0_elvis_lhs_13;
    view_12.gbb(p_13, view_13);
    view_13.lba(view_13.qb6_1.abf(SubtitleSemantic_getInstance()));
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp_29 = view_13.vb5_1;
    var tmp_30;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(content) === 0) {
      tmp_30 = '\xA0';
    } else {
      tmp_30 = content;
    }
    tmp_29.hbu(tmp_30);
    view_12.hbb(p_13, view_13);
    smallBody(view_12, 'Admins are required to have an address on record.');
    view_11.hbb(p_12, view_12);
    view_11.lbb(tmp_28, view_12);
    // Inline function 'com.lightningkite.serialization.lensPath' call
    // Inline function 'com.lightningkite.lightningdb.path' call
    // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
    var tmp_31 = serializerOrContextual(createKType(getKClass(User()), arrayOf([]), false));
    var tmp$ret$80 = isInterface(tmp_31, KSerializer()) ? tmp_31 : THROW_CCE();
    var it_0 = new (DataClassPathSelf())(tmp$ret$80);
    var tmp$ret$82 = get_address(it_0);
    var tmp$ret$83 = lensPath_0(user, tmp$ret$82);
    var tmp0_address = validated(tmp$ret$83, $this.yiv_1);
    var tmp_32 = ($this$addressForm) => !$this$addressForm.daj(upgradingToAdmin);
    addressForm(view_11, tmp0_address, VOID, VOID, tmp_32, ($this$addressForm) => $this$addressForm.daj($this.ziv_1));
    view.hbb(p_11, view_11);
    view.lbb(tmp_27, view_11);
    $this$forEachUpdating.hbb(p, view);
    $this$forEachUpdating.lbb(tmp, view);
    return Unit_instance;
  });
  _this__u8e3s4.hbb(p, view);
  return view;
}
var AddUserDialogClass;
function AddUserDialog() {
  if (AddUserDialogClass === VOID) {
    class $ {
      constructor(membership, startData) {
        startData = startData === VOID ? null : startData;
        this.fjn_1 = membership;
        var tmp = this;
        var tmp_0;
        if (startData == null) {
          var tmp1_email = _EmailAddress___init__impl__a6ugvr('');
          var tmp2_phoneNumber = _PhoneNumber___init__impl__slwhzy('');
          var tmp3_address = new (Address())();
          var tmp4_role = UserRole_Customer_getInstance();
          var tmp5_membership = new (UserMembership())(this.fjn_1.g8c_1, MemberRole_Employee_getInstance());
          tmp_0 = new (User())(VOID, tmp1_email, tmp2_phoneNumber, VOID, '', '', tmp3_address, tmp5_membership, VOID, tmp4_role);
        } else {
          tmp_0 = startData;
        }
        tmp.gjn_1 = validated_0(Draft(tmp_0));
        this.hjn_1 = get_rem(50);
        this.ijn_1 = new (UserForm())(this.gjn_1, true, this.hjn_1);
      }
      wd6(_this__u8e3s4) {
        var tmp = get_scrolling(_this__u8e3s4);
        // Inline function 'com.crowpay.views.components.dismissBackground2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.dismissBackground' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (DismissBackground())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.vbo(ManageContractorUsers$AddUserDialog$render$slambda_0());
        var tmp_0 = view.kbb(get_centered(view), view.jbb(DialogSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (Frame())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view_0.gba(get_AppDimensions().yg1_1);
        var tmp_1 = view_0.jbb(RemoveOutline_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.gbb(p_1, view_1);
        view_1.zbm(true);
        title(view_1, 'Add User');
        var tmp_2 = sizeConstraints(view_1, VOID, VOID, get_rem(20), VOID, VOID, this.hjn_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_2 = view_1.ebb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.gbb(p_2, view_2);
        view_2.zbm(true);
        view_2.bb9(get_AppDimensions().bg2_1);
        render(this.ijn_1, view_2);
        roleSelector(this, view_2);
        view_1.hbb(p_2, view_2);
        view_1.lbb(tmp_2, view_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (Space())(view_1.pc(), 0.5);
        var tmp0_elvis_lhs_3 = view_1.ebb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
        view_1.gbb(p_3, view_3);
        view_1.hbb(p_3, view_3);
        var tmp_3 = get_atEnd(view_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_4 = view_1.ebb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_1 : tmp0_elvis_lhs_4;
        view_1.gbb(p_4, view_4);
        view_4.zbm(false);
        var tmp_4 = get_secondaryButton(view_4);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (Button())(view_4.pc());
        var tmp0_elvis_lhs_5 = view_4.ebb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
        view_4.gbb(p_5, view_5);
        specCenteredText(view_5, 'Go Back');
        onClick(view_5, VOID, VOID, ManageContractorUsers$AddUserDialog$render$slambda_2());
        view_4.hbb(p_5, view_5);
        view_4.lbb(tmp_4, view_5);
        var tmp_5 = get_primaryButton(view_4);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (Button())(view_4.pc());
        var tmp0_elvis_lhs_6 = view_4.ebb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view_4 : tmp0_elvis_lhs_6;
        view_4.gbb(p_6, view_6);
        var tmp_6 = KMutableProperty0();
        var tmp_7 = Button$_get_enabled_$ref_61t7nx(view_6);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_0 = getPropertyCallableRef('enabled', 0, tmp_6, tmp_7, Button$_set_enabled_$ref_o8kynz(view_6));
        reactiveScope(view_6, ($this$reactiveScope) => {
          var tmp$ret$10 = $this$reactiveScope.daj(get_issues(this.gjn_1)).i1();
          this_0.set(tmp$ret$10);
          return Unit_instance;
        });
        specCenteredText(view_6, 'Submit');
        onClick(view_6, 'Submit', VOID, ManageContractorUsers$AddUserDialog$render$slambda_4(this));
        view_4.hbb(p_6, view_6);
        view_4.lbb(tmp_5, view_6);
        view_1.hbb(p_4, view_4);
        view_1.lbb(tmp_3, view_4);
        view_0.hbb(p_1, view_1);
        view_0.lbb(tmp_1, view_1);
        view.hbb(p_0, view_0);
        view.lbb(tmp_0, view_0);
        _this__u8e3s4.hbb(p, view);
        return _this__u8e3s4.lbb(tmp, view);
      }
    }
    protoOf($).wcv = get_title;
    initMetadataForClass($, 'AddUserDialog', VOID, VOID, [Page()]);
    AddUserDialogClass = $;
  }
  return AddUserDialogClass;
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.rjn_1 = function_0;
      }
      wi(a, b) {
        return this.rjn_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.rjn_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function ManageContractorUsers$myRole$lambda($this$remember) {
  var tmp0_safe_receiver = $this$remember.daj($this$remember.daj(get_session()).rfw_1).k88_1;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h8c_1;
  return tmp1_elvis_lhs == null ? MemberRole_Employee_getInstance() : tmp1_elvis_lhs;
}
function ManageContractorUsers$userComparator$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp0_safe_receiver = a.k88_1;
  var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h8c_1;
  var tmp0_safe_receiver_0 = b.k88_1;
  var tmp$ret$1 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.h8c_1;
  return compareValues(tmp, tmp$ret$1);
}
var ManageContractorUsers$addUsersButton$slambdaClass;
function ManageContractorUsers$addUsersButton$slambda() {
  if (ManageContractorUsers$addUsersButton$slambdaClass === VOID) {
    class $ {
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ManageContractorUsers$addUsersButton$slambdaClass = $;
  }
  return ManageContractorUsers$addUsersButton$slambdaClass;
}
function ManageContractorUsers$addUsersButton$slambda_0() {
  var i = new (ManageContractorUsers$addUsersButton$slambda())();
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_2(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_2(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function Select$_get_shown_$ref_flgnnd(p0) {
  return () => p0.yb8();
}
function Select$_set_shown_$ref_q4sxx7(p0) {
  return (_this__u8e3s4) => {
    p0.jb7(_this__u8e3s4);
    return Unit_instance;
  };
}
function Select$_get_enabled_$ref_eg5v13(p0) {
  return () => p0.fbs();
}
function Select$_set_enabled_$ref_fu8bat(p0) {
  return (_this__u8e3s4) => {
    p0.ebs(_this__u8e3s4);
    return Unit_instance;
  };
}
function ManageContractorUsers$renderUserSettings$lambda$lambda(it) {
  return it.a4_1;
}
function TextView$_get_shown_$ref_kipsub(p0) {
  return () => p0.yb8();
}
function TextView$_set_shown_$ref_l7jsq9(p0) {
  return (_this__u8e3s4) => {
    p0.jb7(_this__u8e3s4);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_3(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_3(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
var ManageContractorUsers$renderUserSettings$lambda$slambdaClass;
function ManageContractorUsers$renderUserSettings$lambda$slambda() {
  if (ManageContractorUsers$renderUserSettings$lambda$slambdaClass === VOID) {
    class $ {
      constructor($user) {
        this.mjn_1 = $user;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ManageContractorUsers$renderUserSettings$lambda$slambdaClass = $;
  }
  return ManageContractorUsers$renderUserSettings$lambda$slambdaClass;
}
function ManageContractorUsers$renderUserSettings$lambda$slambda_0($user) {
  var i = new (ManageContractorUsers$renderUserSettings$lambda$slambda())($user);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var ManageContractorUsers$save$slambdaClass;
function ManageContractorUsers$save$slambda() {
  if (ManageContractorUsers$save$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.ojn_1 = this$0;
      }
      yah($this$Action, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this, $this$Action), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ManageContractorUsers$save$slambdaClass = $;
  }
  return ManageContractorUsers$save$slambdaClass;
}
function ManageContractorUsers$save$slambda_0(this$0) {
  var i = new (ManageContractorUsers$save$slambda())(this$0);
  var l = ($this$Action, $completion) => i.yah($this$Action, $completion);
  l.$arity = 1;
  return l;
}
var ManageContractorUsers$render$slambdaClass;
function ManageContractorUsers$render$slambda() {
  if (ManageContractorUsers$render$slambdaClass === VOID) {
    class $ {
      constructor($$this$frame) {
        this.pjn_1 = $$this$frame;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ManageContractorUsers$render$slambdaClass = $;
  }
  return ManageContractorUsers$render$slambdaClass;
}
function ManageContractorUsers$render$slambda_0($$this$frame) {
  var i = new (ManageContractorUsers$render$slambda())($$this$frame);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var ManageContractorUsers$render$slambdaClass_0;
function ManageContractorUsers$render$slambda_1() {
  if (ManageContractorUsers$render$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0) {
        this.qjn_1 = this$0;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_6.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ManageContractorUsers$render$slambdaClass_0 = $;
  }
  return ManageContractorUsers$render$slambdaClass_0;
}
function ManageContractorUsers$render$slambda_2(this$0) {
  var i = new (ManageContractorUsers$render$slambda_1())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var ManageContractorUsersClass;
function ManageContractorUsers() {
  if (ManageContractorUsersClass === VOID) {
    class $ {
      constructor() {
        this.siv_1 = new (Constant())(_Constant___init__impl__v45mub('Manage Users'));
        var tmp = this;
        tmp.tiv_1 = remember(VOID, VOID, VOID, ManageContractorUsers$myRole$lambda);
        var tmp_0 = this;
        // Inline function 'kotlin.comparisons.compareBy' call
        var tmp_1 = ManageContractorUsers$userComparator$lambda;
        // Inline function 'kotlin.comparisons.thenBy' call
        var this_0 = new (sam$kotlin_Comparator$0())(tmp_1);
        var tmp_2 = (a, b) => {
          var previousCompare = this_0.compare(a, b);
          var tmp;
          if (!(previousCompare === 0)) {
            tmp = previousCompare;
          } else {
            // Inline function 'kotlin.comparisons.compareValuesBy' call
            var tmp_0 = new (EmailAddress())(a.e88_1);
            var tmp$ret$2 = new (EmailAddress())(b.e88_1);
            tmp = compareValues(tmp_0, tmp$ret$2);
          }
          return tmp;
        };
        tmp_0.uiv_1 = new (sam$kotlin_Comparator$0())(tmp_2);
        var tmp_3 = this;
        tmp_3.viv_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var session = $this$remember.daj(get_session());
          var tmp0_elvis_lhs = $this$remember.daj(get_selectedContractor());
          var tmp;
          if (tmp0_elvis_lhs == null) {
            return emptyList();
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var contractor = tmp;
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(User()), arrayOf([]), false));
          var tmp$ret$5 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$5);
          var tmp$ret$9 = eq(get_contractor(get_notNull(get_membership(it))), contractor);
          return sortedWith($this$remember.daj(session.afw_1.heo(new (Query())(tmp$ret$9))), this.uiv_1);
        });
        this.wiv_1 = HashMap().n8();
        var tmp_4 = this;
        tmp_4.xiv_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.map' call
          var this_0 = $this$remember.daj(this.viv_1);
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
          var _iterator__ex2g4s = this_0.m1();
          while (_iterator__ex2g4s.n1()) {
            var item = _iterator__ex2g4s.o1();
            var tmp0 = this.wiv_1;
            // Inline function 'kotlin.collections.getOrPut' call
            var key = item.d88_1;
            var value = tmp0.p3(key);
            var tmp;
            if (value == null) {
              var answer = Draft(item);
              tmp0.s3(key, answer);
              tmp = answer;
            } else {
              tmp = value;
            }
            var tmp$ret$12 = tmp;
            destination.v(tmp$ret$12);
          }
          return destination;
        });
        this.yiv_1 = new (IssueNode())();
        this.ziv_1 = Signal().hak(false);
      }
      wcv() {
        return this.siv_1;
      }
      aiw(writer) {
        return Action('Save Changes', VOID, ManageContractorUsers$save$slambda_0(this));
      }
      wd6(_this__u8e3s4) {
        var tmp = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (Frame())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        launch(view, VOID, VOID, ManageContractorUsers$render$slambda_0(view));
        var tmp_0 = sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, get_AppDimensions().gg2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view_0.zbm(true);
        title(view_0, 'Users');
        view_0.lbb(view_0.kbb(get_atEnd(view_0), get_tertiaryButton(view_0)), addUsersButton(this, view_0));
        renderUserSettings(this, view_0);
        var tmp_1 = get_atEnd(view_0);
        var tmp_2 = view_0.kbb(tmp_1, shownWhen(view_0, VOID, ($this$shownWhen) => {
          var tmp0 = $this$shownWhen.daj(this.xiv_1);
          var tmp$ret$0;
          $l$block_0: {
            // Inline function 'kotlin.collections.any' call
            var tmp;
            if (isInterface(tmp0, Collection())) {
              tmp = tmp0.i1();
            } else {
              tmp = false;
            }
            if (tmp) {
              tmp$ret$0 = false;
              break $l$block_0;
            }
            var _iterator__ex2g4s = tmp0.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              if ($this$shownWhen.daj(element.cak())) {
                tmp$ret$0 = true;
                break $l$block_0;
              }
            }
            tmp$ret$0 = false;
          }
          return tmp$ret$0;
        }));
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.gbb(p_1, view_1);
        view_1.zbm(false);
        var tmp_3 = get_secondaryButton(view_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (Button())(view_1.pc());
        var tmp0_elvis_lhs_2 = view_1.ebb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.gbb(p_2, view_2);
        specCenteredText(view_2, 'Discard');
        onClick(view_2, VOID, VOID, ManageContractorUsers$render$slambda_2(this));
        view_1.hbb(p_2, view_2);
        view_1.lbb(tmp_3, view_2);
        var tmp_4 = get_primaryButton(view_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (Button())(view_1.pc());
        var tmp0_elvis_lhs_3 = view_1.ebb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
        view_1.gbb(p_3, view_3);
        specCenteredText(view_3, 'Save Changes');
        view_3.obg(this.aiw(view_3));
        view_1.hbb(p_3, view_3);
        view_1.lbb(tmp_4, view_3);
        view_0.hbb(p_1, view_1);
        view_0.lbb(tmp_2, view_1);
        view.hbb(p_0, view_0);
        view.lbb(tmp_0, view_0);
        _this__u8e3s4.hbb(p, view);
        return _this__u8e3s4.lbb(tmp, view);
      }
      dix(writer) {
        // Inline function 'kotlin.with' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(writer.pc());
        var tmp0_elvis_lhs = writer.ebb_1;
        var p = tmp0_elvis_lhs == null ? writer : tmp0_elvis_lhs;
        writer.gbb(p, view);
        view.zbm(true);
        view.lbb(view.kbb(get_atStart(view), get_tertiaryButton(view)), addUsersButton(this, view));
        renderUserSettings(this, view);
        writer.hbb(p, view);
        return view;
      }
    }
    initMetadataForClass($, 'ManageContractorUsers', ManageContractorUsers, VOID, [Page()]);
    ManageContractorUsersClass = $;
  }
  return ManageContractorUsersClass;
}
//region block: exports
export {
  ManageContractorUsers as ManageContractorUsers27kb1m7q8tkdk,
};
//endregion

//# sourceMappingURL=ManageContractorUsers.mjs.map
